export const decodeImg = async (src: string): Promise<void> => {
  const img = new Image()
  img.src = src
  return img.decode()
}
